import isDev from '../_shared/utils/isDev';
import pjson from '../../package.json';
import { CHECKOUT_PHOTO_BASE_URL, EDITOR_PHOTO_BASE_URL, RESERVED_AREA_BASE_URL } from '@env';
import { PhotosiSdk } from '@photosi/expo-photosi-sdk/build/PhotosiSdk';

export const USER_TOKEN_COOKIE: string = 'userToken';
export const PHS_TOKEN_COOKIE: string = 'phsToken';

export const USER_IS_RETAILER_COOKIE: string = 'isRetailer';
export const LANGUAGE_COOKIE: string = 'phs_choosen_language';

export const AVAILABLE_LANGUAGES: string[] = ['it', 'en', 'es']; //, , 'fr', 'de', 'nl']

export const BRAZE_SERVICE_WORKER_LOCATION: string = isDev()
  ? 'https://cookie-test.photoforse.online/hubfs/photosi2021_DEV/braze/service-worker.js'
  : 'https://www.photosi.com/hubfs/photosi2021/braze/service-worker.js';

export const WEBSITE_BASE_URL = 'https://www.photosi.com/';

// local editor uses ENV=DEV but a different EDITOR_PHOTO_BASE_URL
export const EDITOR_BASE_URL = __DEV__ ? 'https://local.photoforse.online:8082' : EDITOR_PHOTO_BASE_URL;
export const CHECKOUT_BASE_URL = __DEV__ ? 'https://local.photoforse.online:3000' : CHECKOUT_PHOTO_BASE_URL;
export const SAVED_PROJECTS_URL = `${RESERVED_AREA_BASE_URL}/projects`;

export const APP_NAME = pjson.name;
export const APP_VERSION = pjson.version;

export const SDK_VERSION = PhotosiSdk.version ?? '';
export const SDK_LIBHEIF_VERSION = PhotosiSdk.libheifVersion ?? '';

export const SDK_REMOTES = [
  `${EDITOR_BASE_URL}/vendors/photosi-sdk-web-${SDK_VERSION.replaceAll('.', '-')}.js`,
  `${EDITOR_BASE_URL}/vendors/libheif-bundle-${SDK_LIBHEIF_VERSION}.js`,
];

export const USE_RESPONSIVE_SCALE_CONTEXT = true;

export const getDependencyVersion = (dependency: string): string => {
  return pjson.dependencies[dependency as keyof typeof pjson.dependencies];
};
